import { isNil } from "lodash";
import { FunctionComponent, useEffect } from "react";
import {
  createSearchParams,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";

type Props = {};

export const CheckForError: FunctionComponent<Props> = (
  props: Props
): JSX.Element => {
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const navigate = useNavigate();
  const error = searchParams.get("error");
  const description = searchParams.get("error_description") ?? "Unknown error";

  useEffect(() => {
    if (!isNil(error) && location.pathname !== "/error") {
      navigate({
        pathname: "/error",
        search: `?${createSearchParams({
          title: error,
          description: description,
        })}`,
      });
    }
  }, [description, error, location.pathname, navigate]);

  return <></>;
};
